import request from './axios'
// import requestSec from './axiosSec'
// 获取验证码
export const getCaptcha = (data) => request({
  url: 'captcha/get',
  method: 'post',
  data: data
})

// 获取业务系统登陆使用的token
export const getTicket = (data) => request({
  url: 'sso/getTicket',
  method: 'post',
  data: data
})

// 注册
export const register = (data) => request({
  url: 'sso/register',
  method: 'post',
  data: data
})

// 登录
export const login = (data) => request({
  url: 'sso/Login',
  method: 'post',
  data: data
})

// 微信扫码登录
export const wxLogin = (data) => request({
  url: 'sso/wechatLogin',
  method: 'post',
  data: data
})

// 找回五十三ID
export const retrieveUsername = (data) => request({
  url: 'sso/forgetUsername',
  method: 'post',
  data: data
})

// 手机号找回密码
export const resetPasswordByMobile = (data) => request({
  url: 'sso/forgetPassword',
  method: 'post',
  data: data
})

// 修改密码（重置密码）
export const resetPassword = (data) => request({
  url: 'sso/resetPassword',
  method: 'post',
  data: data
})



// WEBPACK FOOTER //
// ./src/api/api.js